import { CompanyPartialProfile } from "../Company/Company.type";

export type PracticeData = {
  id: string;
  name: string;
  alias: string;
  hiddenInPc?: boolean;
};

export type PracticesResponseService = PracticeData[];

export type Position = {
  id: string;
  name: string;
  alias: string;
};

export type ExamData = {
  id: string;
  name: string;
  alias: string;
  form: any;
  practices: PracticesResponseService;
};

export type ExamDataResponseService = ExamData[];

export type MoldeData = {
  id: string;
  name: string;
  type: string;
  position: Position;
  form: any;
  company?: CompanyPartialProfile;
  practices: PracticesResponseService;
  exams: ExamDataResponseService;
};

export type MoldeDataResponseService = MoldeData[];

export enum GenericsOptions {
  YES = "si",
  NO = "no",
}

export type MoldesQuery = {
  companyId?: string;
  generics?: GenericsOptions;
};
